import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Header from './header'
import Sidebar from './sidebar'
import { useSelector } from 'react-redux'

const Layout = ({ isSignedIn }) => {

    const location = useLocation()

    const { toggle } = useSelector((state) => state.admin_panel.User);

    if (!isSignedIn) {
        return <Navigate to="/signin" replace />;
    }

    if (isSignedIn && location.pathname === '/') {
        return <Navigate to="/dashboard" />;
    }

    return (
        <div>
            <div className="innerpages">
                <div className="orders_pages">
                    <Header />
                    <div className="container custom_container px-lg-0">
                        <div className="row mx-auto">
                            <div className="innerpages_wid px-0">
                                <Sidebar />
                                <div
                                    className={
                                        toggle
                                            ? "content-sec-inner right_widthset content_without_sidebar"
                                            : "content-sec-inner  content_with_sidebar"
                                    }
                                >
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Layout